import React, { useState, useEffect } from "react";
import useFetchInfo from "../../utils/useFetchInfo";
import { useParams, useNavigate } from "react-router-dom";
import apiServer from "../../constants/apiServer";
import { img_url_api } from "../../constants/apiImg";
import SquareLoading from "../../common/SquareLoading";
import { checkFormValidate } from "../../utils/commonFuncs";
import { put } from "../../utils/api";
import { handleApiError, handleApiSuccess } from "../../utils/errorHandler";
import PopupLoading from "../../common/PopupLoading";
import AdaAlert from "../../common/AdaAlert";
import BannerForm from "./BannerForm";
import EmptyPage from "../../common/EmptyPage";

const UpdateBanner = () => {
    const { bannerId } = useParams();
    const navigate = useNavigate();

    const [bannerInfoValues, setBannerInfoValues] = useState({
        name: "",
        banner_type: 1,
        is_active: 1,
        remark: "",
        imageList: [],
        deleteImageList: [],
    });

    console.log("bannerInfoValues", bannerInfoValues);

    const { name, imageList, deleteImageList } = bannerInfoValues;

    const [errorInfoList, setErrorInfoList] = useState({});
    const [updateLoading, setUpdateLoading] = useState(false);
    const [getInfoLoading, setGetInfoLoading] = useState(false);
    const [getInfoError, setGetInfoError] = useState("");
    const [updateError, setUpdateError] = useState("");

    const { data, isLoading, error } = useFetchInfo(
        `${apiServer.banner.getDetail}/${bannerId}`
    );

    useEffect(() => {
        const bannerMediaList = data?.media || [];
        const bannerImageList = [];
        for (let i = 0; i < bannerMediaList?.length; i++) {
            bannerImageList.push({
                id: bannerMediaList[i]?.id,
                caption: bannerMediaList[i]?.caption || "",
                file: bannerMediaList[i]?.file,
                type: bannerMediaList[i]?.media_type,
                src: img_url_api + bannerMediaList[i]?.file,
                status: "uploaded",
            });
        }
        setBannerInfoValues({
            name: data?.name || "",
            banner_type: parseInt(data?.banner_type) || 1,
            is_active: data?.is_active ? 1 : 0,
            remark: data?.remark || "",
            imageList: bannerImageList,
            deleteImageList: [],
        });
        setGetInfoError(error);
        setGetInfoLoading(isLoading);
    }, [data, isLoading, error]);

    const handleChangeInput = (event) => {
        const { name, value } = event.target;
        setBannerInfoValues((generalInfo) => {
            return {
                ...generalInfo,
                [name]:
                    name === "banner_type" || name === "is_active"
                        ? parseInt(value)
                        : value,
            };
        });
        delete errorInfoList[name];
        setErrorInfoList(errorInfoList);
    };

    const handleUploadImg = (imgInfo) => {
        setBannerInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                imageList: [...prevInfo["imageList"], imgInfo],
            };
        });
    };

    const handleChangeCaption = (value, imageInfo) => {
        const modifiedImageList = bannerInfoValues["imageList"];
        let modifiedImageId = modifiedImageList.findIndex(
            (element) => element.id === imageInfo.id
        );
        modifiedImageList[modifiedImageId]["caption"] = value;
        setBannerInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                imageList: modifiedImageList,
            };
        });
    };

    const handleRemoveImage = (imageInfo) => {
        setBannerInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                imageList: bannerInfoValues["imageList"].filter(
                    (element) => element !== imageInfo
                ),
                deleteImageList: [...prevInfo["deleteImageList"], imageInfo],
            };
        });
    };

    const handleCancleUpdate = () => {
        navigate("/banners", { replace: true });
    };

    const handleUpdateBanner = async (event) => {
        event.preventDefault();
        const infoValue = {
            name: bannerInfoValues.name,
            banner_type: bannerInfoValues.banner_type,
            is_active: bannerInfoValues.is_active,
            remark: bannerInfoValues.remark,
            imageList: bannerInfoValues.imageList,
            deleteImageList: bannerInfoValues.deleteImageList,
        };

        const checkFormValues = checkFormValidate(infoValue);
        
        setErrorInfoList(checkFormValues);
        if (Object.keys(checkFormValues).length === 0 && name.length < 100) {
            setUpdateLoading(true);
            const body = new FormData();
            
            // Send multiple media files if new ones are uploaded
            const newImages = imageList.filter(image => image.status !== "uploaded");
            if (newImages.length > 0) {
                newImages.forEach((image, index) => {
                    if (image?.file) {
                        body.append('media_files', image.file);
                    }
                });

                // Send captions array for new images
                const captions = newImages.map(image => image.caption || '');
                captions.forEach((caption, index) => {
                    body.append(`captions[${index}]`, caption);
                });
            }

            if(deleteImageList.length > 0){
                const deleteImageIds = deleteImageList.map(image => image.id);
                body.append('delete_media_ids', deleteImageIds);
            }

            // Send other form fields, excluding imageList and deleteImageList
            Object.keys(bannerInfoValues).forEach((element) => {
                if (element !== 'imageList' && element !== 'deleteImageList') {
                    body.append(element, bannerInfoValues[element]);
                }
            });
            
            // body.append("id", bannerId);
            const bannerURL = `${apiServer.banner.update}/${bannerId}`;

            try {
                const response = await put(bannerURL, body);
                const data = handleApiSuccess(response, setUpdateLoading);
                
                navigate("/banners", {
                    replace: true,
                    state: { status: "success", message: data.message },
                });
            } catch (error) {
                handleApiError(error, setUpdateError, setUpdateLoading);
            }
        }
    };

    if (getInfoLoading)
        return <SquareLoading text="Retrieving Information..." />;

    if (getInfoError) return <EmptyPage text={getInfoError} />;

    if (updateLoading)
        return <PopupLoading text="Updating Banner Information..." />;

    return (
        <>
            <BannerForm
                formTitle={"Update Banner"}
                onSubmitName="Update"
                onCreate={handleUpdateBanner}
                onCancel={handleCancleUpdate}
                onChangeValue={handleChangeInput}
                onUploadImg={handleUploadImg}
                onRemoveImg={handleRemoveImage}
                infoValues={bannerInfoValues}
                errorValues={errorInfoList}
                onChangeCaption={handleChangeCaption}
            />

            {updateError !== "" && (
                <AdaAlert type="error" message={updateError} />
            )}
        </>
    );
};

export default UpdateBanner;
